// La courbe du 1RM estimé qui se trace, avec la valeur et la hausse.
import React from "react";
import Apercu from "./Apercu";
import { COURBE_1RM } from "./donneesDemo";

const L = 300;
const H = 110;

// Coordonnées du tracé dans un viewBox de L × H (marge haute pour le dernier point).
function points(valeurs) {
	const min = Math.min(...valeurs) - 2;
	const max = Math.max(...valeurs) + 1;
	return valeurs.map((v, i) => [
		Math.round((i / (valeurs.length - 1)) * L),
		Math.round(H - ((v - min) / (max - min)) * (H - 10)),
	]);
}

export default function ApercuCourbe1RM({ boucle = false, className = "", exercice = "Développé couché" }) {
	const { mois, valeurs } = COURBE_1RM;
	const pts = points(valeurs);
	const trait = pts.map(([x, y], i) => `${i ? "L" : "M"}${x} ${y}`).join(" ");
	const aire = `${trait} L${L} ${H} L0 ${H} Z`;
	const [dx, dy] = pts[pts.length - 1];
	const hausse = Math.round(((valeurs[valeurs.length - 1] - valeurs[0]) / valeurs[0]) * 100);
	const derniere = String(valeurs[valeurs.length - 1]).replace(".", ",");

	return (
		<Apercu
			boucle={boucle}
			className={className}
			description={`1RM estimé au ${exercice.toLowerCase()} : ${derniere} kg, en hausse de ${hausse} % sur six mois.`}
		>
			<div className="gs-a-carte gs-a-courbe">
				<div className="gs-a-lbl">1RM estimé · {exercice}</div>
				<div className="gs-a-valeur">
					{derniere} kg <span className="gs-a-hausse">+{hausse} %</span>
				</div>
				<svg viewBox={`0 0 ${L} ${H}`} preserveAspectRatio="none">
					<defs>
						<linearGradient id="gs-a-degrade-1rm" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor="#30a49a" stopOpacity="0.28" />
							<stop offset="100%" stopColor="#30a49a" stopOpacity="0" />
						</linearGradient>
					</defs>
					<path className="gs-a-aire" d={aire} fill="url(#gs-a-degrade-1rm)" />
					<path
						className="gs-a-trait"
						d={trait}
						pathLength="100"
						fill="none"
						stroke="#30a49a"
						strokeWidth="2.5"
						strokeLinejoin="round"
						strokeLinecap="round"
						vectorEffect="non-scaling-stroke"
					/>
					<circle className="gs-a-dernier-point" cx={dx} cy={dy} r="4.5" fill="#30a49a" stroke="#fff" strokeWidth="2" vectorEffect="non-scaling-stroke" />
				</svg>
				<div className="gs-a-axe">
					{mois.map((m) => (
						<span key={m}>{m}</span>
					))}
				</div>
			</div>
		</Apercu>
	);
}
